import React from 'react';

import { getActionType } from '../../../../sharedModules/getActionType';
import type { Deal } from '../../../types/Deal';
import { HawkWidgetContext } from '../HawkWidget/HawkWidgetContext';

import styles from './styles/view-at.css';

interface ViewAtProps {
  deal: Deal;
  className?: string;
}

const ViewAt: React.FC<ViewAtProps> = ({ deal, className }) => (
  <HawkWidgetContext.Consumer>
    {(value): JSX.Element => {
      const {
        articleUrl,
        translate,
        genericSharedComponents: { AffiliateLink },
      } = value;
      const containerStyle = className && styles[className] ? className : 'container';
      const merchantName = deal?.merchant?.name ?? '';

      return (
        <div className={styles[containerStyle]}>
          <span>{translate('viewAtBlockLabel')} </span>
          <AffiliateLink
            deal={deal}
            className={className || 'underline'}
            actionType={getActionType({
              link: deal.offer.link,
              articleUrl,
              productType: deal.product_type,
            })}
          >
            {merchantName}
          </AffiliateLink>
        </div>
      );
    }}
  </HawkWidgetContext.Consumer>
);

export default ViewAt;
